var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table table-style2 table-striped with-edit"},[_c('draggable',{attrs:{"options":{draggable:'.item', handle:'.handle'},"element":"tbody"},on:{"end":_vm.reorder},model:{value:(_vm.arr),callback:function ($$v) {_vm.arr=$$v},expression:"arr"}},[_vm._t("body",null,{arr:_vm.arr})],2)],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-821df950","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/DragDropOrdering/DragDropOrdering.vue
// module id = tgDW
// module chunks = 0 1 3 4 5 6 7 8 9